import generateLocaleAwarePolicyIndex from '../../utils';
import * as types from './types';

function setContentData(params, data) {
    const index = generateLocaleAwarePolicyIndex(params);

    return {
        meta: index,
        payload: data,
        type: types.SET_CONTENT_DATA,
    };
}

export {
    setContentData,
};
